"use client";

import { useEffect, useState } from "react";

export function LandingCredibilityStrip() {
  const [logos, setLogos] = useState<string[]>([]);

  useEffect(() => {
    fetch("/api/dev-logos")
      .then((r) => r.json())
      .then((files: string[]) => setLogos(files))
      .catch(() => {});
  }, []);

  if (logos.length === 0) return null;

  const doubled = [...logos, ...logos, ...logos, ...logos];

  return (
    <section className="border-y border-black/5 bg-[hsl(var(--lb-bg-soft))] py-4">
      <div className="mx-auto mb-3 text-center text-sm font-semibold uppercase tracking-[0.08em] text-black/45">
        Trusted by Developers such as:
      </div>
      <div className="overflow-hidden">
        <div className="animate-marquee flex min-w-max items-center gap-12 px-8 lg:gap-20">
          {doubled.map((src, index) => (
            <div
              key={`${src}-${index}`}
              className="flex h-14 min-w-[11rem] items-center justify-center"
            >
              <img
                src={src}
                alt=""
                className="max-h-14 max-w-[14rem] object-contain opacity-70 grayscale brightness-0 dark:brightness-100"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
